import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { api, useGetLeaderboardQuery } from '../store/api/api';
import { ThreadExcerpt } from '../components/shelves/ThreadExcerpt';
import { AddCommentDialog } from '../components/shelves/comments/AddCommentDialog';
import {
  selectThreadsByUser,
  useGetThreadsQuery,
} from '../store/api/threadsApi';
import { selectUserById, useGetUsersQuery } from '../store/api/usersApi';
import { ProfileHeader } from '../components/shelves/users/ProfileHeader';
import { UserPageSkeleton } from '../components/shelves/transitions/UserPageSkeleton';

export function UserPage() {
  const { userId } = useParams();
  const dispatch = useDispatch();
  const {
    isUninitialized: threadsNotLoadedYet,
    isLoading: loadingThreads,
    data: threadsData,
    isError: loadingThreadsFailed,
  } = useGetThreadsQuery();

  const {
    isUninitialized: usersNotLoadedYet,
    isLoading: loadingUsers,
    data: users,
    isError: loadingUsersFailed,
  } = useGetUsersQuery();

  const { isUninitialized: leaderboardNotLoadedYet, data: leaderboard } =
    useGetLeaderboardQuery();

  const threads = useSelector((state) => selectThreadsByUser(state, userId));
  const profile = useSelector((state) => selectUserById(state, userId));

  const [score, setScore] = useState(0);

  useEffect(() => {
    if (threadsNotLoadedYet) dispatch(api.endpoints.getThreads.initiate());
    if (usersNotLoadedYet) dispatch(api.endpoints.getUsers.initiate());
    if (leaderboardNotLoadedYet)
      dispatch(api.endpoints.getLeaderboard.initiate());

    let userStat;
    if (leaderboard)
      userStat = leaderboard.find(({ user }) => user.id === userId);

    if (userStat) setScore(userStat.score);
  }, [
    dispatch,
    leaderboard,
    leaderboardNotLoadedYet,
    threadsNotLoadedYet,
    userId,
    usersNotLoadedYet,
  ]);

  return (
    <section className="container mx-auto mt-8 mb-16 max-w-[600px] break-words px-2 2xl:max-w-2xl">
      {loadingThreads && loadingUsers ? <UserPageSkeleton /> : ''}

      {threadsData && users ? (
        <>
          <ProfileHeader
            ava={profile.avatar}
            id={profile.id}
            name={profile.name}
            email={profile.email}
            score={score}
          />
          {threads.length > 0 ? (
            <>
              <h2 className="mt-4 mb-4 text-lg font-semibold">
                Threads by {profile.name}
              </h2>
              <ul className="mb-10 grid divide-y divide-gray-200 overflow-hidden dark:divide-gray-800">
                {threads.map((thread) => (
                  <li
                    key={thread.id}
                    className="py-2 hover:bg-indigo-500/5 dark:hover:bg-indigo-900/5"
                  >
                    <ThreadExcerpt thread={thread} />
                  </li>
                ))}
              </ul>
            </>
          ) : (
            <div className="grid h-80 place-items-center text-center">
              {profile.name}&lsquo;s threads will appear here <br />
              if available
            </div>
          )}
        </>
      ) : (
        ''
      )}
      {loadingThreadsFailed || loadingUsersFailed ? (
        <div className="my-4">Nothing to see here</div>
      ) : (
        ''
      )}
      <AddCommentDialog />
    </section>
  );
}
